import type { FC } from 'react';
import { StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';

interface Props {
	title: string;
	subtitle?: string;
	underline?: boolean;
	style?: StyleProp<ViewStyle>;
}

const SectionTitle: FC<Props> = ({ title, subtitle, underline = true, style }) => {
	return (
		<View style={style}>
			<Text style={styles.title}>{title}</Text>
			{subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
			{underline ? <View style={styles.underline} /> : null}
		</View>
	);
};

const styles = StyleSheet.create({
	title: {
		fontSize: Dimens.fontSize22,
		fontFamily: Fonts.ptSerif,
		color: Colors.gray900,
	},
	subtitle: {
		fontSize: Dimens.fontSize14,
		fontFamily: Fonts.barlow,
		color: Colors.gray550,
	},
	underline: {
		backgroundColor: Colors.green,
		width: Dimens.size40,
		height: Dimens.size2,
		marginTop: Dimens.padding12,
	},
});

export default SectionTitle;
